export const loginStyles = theme => {
  const mobile = theme.breakpoints.down("sm");
  const desktop = theme.breakpoints.up("md");
  return {
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing(4),
      [mobile]: {
        paddingBottom: 32,
      },
      [desktop]: {
        paddingBottom: 100,
      },
    },
    submit: {
      float: "right",
      display: "block",
      borderRadius: 3,
      width: 100,
      [mobile]: {
        marginTop: 0,
      },
      [desktop]: {
        marginTop: 40,
      },
    },
    formControl: {
      borderRadius: "4px 4px 0px 0px",
      background: theme.palette.background.default,
      height: 56,
    },
    password: {
      marginBottom: 25,
    },
    inputLabel: {
      paddingLeft: 16,
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    input: {
      padding: "0 16px",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
      position: "static",
      "&:before": {
        height: "100%",
        borderBottom: `2px solid ${theme.palette.text.secondary}`,
      },
    },
    blueButton: {
      color: theme.palette.text.blue,
      background: "transparent",
      border: "none",
      textTransform: "uppercase",
      cursor: "pointer",
      width: 40,
    },
    headline: {
      color: theme.palette.text.lightgrey,
      paddingBottom: 50,
    },
    resetInstructions: {
      display: "block",
      paddingBottom: 20,
    },
  };
};
